.m-xml-json-viewer {
  position: relative;
  border: 1px solid var(--border-colour);
  border-radius: 6px;
  background: var(--grey-lightest);
  overflow: hidden;

  &--wrap {
    // A block element already fills its container; setting width: 100% here
    // ignores any horizontal margin the parent applies (e.g. a card's child
    // inset) and overflows the container to the right. ENG-21348
    max-width: 100%;

    .m-xml-json-viewer__content {
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
  }

  &__toolbar {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__copy {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    appearance: none;
    background: var(--white);
    border: 1px solid var(--border-colour);
    border-radius: 4px;
    color: var(--text-color-light);
    cursor: pointer;

    &:hover {
      background: var(--hover-background);
    }

    &:focus-visible {
      outline: 3px solid var(--focus-ring);
      outline-offset: 2px;
    }

    &--copied {
      color: #00814c; // matches the accessible JSON green
    }
  }

  &__badge-icon {
    // sits inline before the badge label (badge is inline-block from MBadge)
    vertical-align: middle;
    margin-right: 2px;
  }

  &__copy-icon {
    display: block;
  }

  &__content {
    margin: 0;
    padding: 12px 16px;
    overflow-x: auto;
    font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
    font-size: 12px;
    line-height: 1.5;
    color: var(--text-color);
    white-space: pre;
    tab-size: 2;
  }
}
